<!-- src/App.vue -->
<template>
  <div id="app">
    <router-view />  <!-- Renders the active route's component -->
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
#app {
  font-family: 'Plus Jakarta Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
  margin: 0;
}

:root {
    --vinrod: #701131;
    --hallonrod: #B5223F;
    --ljusorange: #F49E88;
}

/* Global font style */
body {
    font-family: 'Plus Jakarta Sans', sans-serif;
    background-color: #ffffff;
    color: var(--vinrod); /* Set a neutral color for body text */
}

/* Headings */
h1, h2, h3, h4, h5, h6 {
    color: var(--vinrod); /* Use Vinröd for main headings */
}

/* Buttons */
.button-primary {
    background-color: var(--vinrod);
    color: #ffffff;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.button-primary:hover {
    background-color: var(--hallonrod); /* Hallonröd on hover for contrast */
}

/* Secondary elements and highlights */
.highlight {
    color: var(--hallonrod); /* Use Hallonröd for links or important text */
}

.alert {
    background-color: var(--hallonrod);
    color: #ffffff;
    padding: 10px;
    border-radius: 4px;
}

/* Light sections and backgrounds */
.section-background {
    background-color: var(--ljusorange); /* Soft background for sections */
    padding: 20px;
    border-radius: 8px;
}

/* Card component styling */
.card {
    background-color: #ffffff;
    border: 1px solid var(--ljusorange);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    padding: 15px;
    border-radius: 8px;
}

.card-header {
    color: var(--vinrod);
    font-weight: 700;
    margin-bottom: 10px;
}

.card-content {
    color: var(--vinrod);
    font-size: 1em;
}

</style>
